let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aM9Tn")).then(() => parcelRequire('jACzc'));